import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import AdminNavbar from "../Layout/AdminNavbar";
import API_BASE_URL from "../config";

const ViewLeaveCreditLogs = () => {
  const [logs, setLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [search, setSearch] = useState("");
  const [yearFilter, setYearFilter] = useState("All");
  const [currentPage, setCurrentPage] = useState(1);
  const [logsPerPage] = useState(9);
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("All");


  useEffect(() => {
    fetchLogs();
  }, []);

  // 🔐 Authentication check
 useEffect(() => {
  const token = localStorage.getItem("token");
  const roles = JSON.parse(localStorage.getItem("roles") || "[]");

  if (!token) {
    toast.error("You must be logged in to access this page.");
    navigate("/");
    return;
  }

  // ✅ check admin role
  if (!roles.includes("ROLE_ADMIN")) {
    toast.error("You are not authorized to access this page.");
    navigate("/");
    return;
  }
}, [navigate]);


  useEffect(() => {
    const bootstrapLink = document.createElement("link");
    bootstrapLink.rel = "stylesheet";
    bootstrapLink.href =
      "https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css";
    document.head.appendChild(bootstrapLink);

    const iconsLink = document.createElement("link");
    iconsLink.rel = "stylesheet";
    iconsLink.href =
      "https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css";
    document.head.appendChild(iconsLink);

    return () => {
      bootstrapLink.remove();
      iconsLink.remove();
    };
  }, []);


  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    fetch(`${API_BASE_URL}/api/users`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((data) => {
        const activeUsers = data.filter((u) => u.status === "Active");
        setUsers(activeUsers);
      })
      .catch((err) => console.error("Error fetching users:", err));
  }, []);


  const fetchLogs = () => {
    const token = localStorage.getItem("token");
    fetch(`${API_BASE_URL}/api/admin/leave-credits`, {
      headers: { Authorization: "Bearer " + token },
    })
      .then((res) => res.json())
      .then((data) => {
        setLogs(data);
        setFilteredLogs(data);
      })
      .catch((err) => console.error("Error fetching logs:", err));
  };

  // 🔍 Filter logs by employee name and year
  useEffect(() => {
    let tempLogs = logs;

    if (selectedUser !== "All") {
  tempLogs = tempLogs.filter(
    (log) => log.employeeName === selectedUser
  );
}


    if (yearFilter !== "All") {
      tempLogs = tempLogs.filter((log) => {
        const logYear = new Date(log.creditedDate).getFullYear().toString();
        return logYear === yearFilter;
      });
    }

    setFilteredLogs(tempLogs);
    setCurrentPage(1);
  }, [selectedUser, yearFilter, logs]);

  const handleDelete = (id) => {
    if (!window.confirm("Are you sure you want to delete this log?")) return;

    const token = localStorage.getItem("token");
    fetch(`${API_BASE_URL}/api/admin/leave-credits/${id}`, {
      method: "DELETE",
      headers: { Authorization: "Bearer " + token },
    })
      .then((res) => {
        if (res.ok) {
          alert("✅ Log deleted successfully");
          fetchLogs();
        } else {
          alert("❌ Failed to delete log");
        }
      })
      .catch((err) => console.error("Error deleting log:", err));
  };

  const indexOfLastLog = currentPage * logsPerPage;
  const indexOfFirstLog = indexOfLastLog - logsPerPage;
  const currentLogs = filteredLogs.slice(indexOfFirstLog, indexOfLastLog);
  const totalPages = Math.ceil(filteredLogs.length / logsPerPage);

  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  const years = Array.from(
    new Set(logs.map((log) => new Date(log.creditedDate).getFullYear()))
  ).sort((a, b) => b - a);

  return (
    <>
      <div className="fixed-top">
        <AdminNavbar />
      </div>

      <div
        className="d-flex flex-column bg-light"
        style={{
          minHeight: "100vh",
          paddingTop: "130px",
          overflowX: "hidden",
        }}
      >
        <div className="flex-grow-1 px-4 pb-5">
          {/* ✅ Header Row with New Button */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h3 className="fw-bold text-dark mb-0">📑 Leave Credit Logs</h3>

            <button
              className="btn btn-sm btn-primary px-2"
              onClick={() => navigate("/assignleaves")} // ← Change this path to your Add page route
            >
              <i className="bi bi-plus-circle me-2"></i>New
            </button>
          </div>

          {/* Filters Row */}
          <div className="d-flex flex-wrap align-items-center gap-3 mb-4">
            {/* User dropdown */}
            <div className="d-flex align-items-center">
              <label className="me-2 fw-semibold">Employee:</label>
              <select
                className="form-select form-select-sm"
                style={{ width: "250px" }}
                value={selectedUser}
                onChange={(e) => setSelectedUser(e.target.value)}
              >
                <option value="All">All Employees</option>

                {users.map((u) => (
                  <option key={u.id} value={u.name}>
                  {u.name}
                </option>
                ))}
              </select>
            </div>


            {/* Year Filter */}
            <div className="d-flex align-items-center">
              <label className="me-2 fw-semibold">Year:</label>
              <select
                className="form-select form-select-sm"
                style={{ width: "150px" }}
                value={yearFilter}
                onChange={(e) => setYearFilter(e.target.value)}
              >
                <option value="All">All Years</option>
                {years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Table Section */}
          <div className="card shadow-sm border-0 h-100" style={{ minHeight: "60vh" }}>
            <div className="card-body p-0">
              <div
                className="table-responsive"
                style={{ maxHeight: "65vh", overflowY: "auto" }}
              >
                <table className="table align-middle mb-0">
                  <thead className="table-secondary text-start sticky-top top-0">
                    <tr>
                      <th>Employee Name</th>
                      <th>Leave Type</th>
                      <th>Credited Date</th>
                      <th>Credited Days</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody className="text-center">
                    {currentLogs.length > 0 ? (
                      currentLogs.map((log) => (
                        <tr key={log.id}>
                          <td className="text-start">{log.employeeName}</td>
                          <td className="text-start">{log.leaveType}</td>
                          <td className="text-start">
                            {new Date(log.creditedDate).toLocaleDateString()}
                          </td>
                          <td className="text-start">{log.creditDays}</td>
                          <td className="text-start">
                            <button
                              className="btn btn-sm "
                              onClick={() => handleDelete(log.id)}
                            >
                              <i className="bi bi-trash3"></i>
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-muted py-4">
                          ❌ No leave credit logs found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <nav className="mt-4">
              <ul className="pagination justify-content-center mb-0">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageChange(currentPage - 1)}
                  >
                    Previous
                  </button>
                </li>

                {Array.from({ length: totalPages }, (_, i) => (
                  <li
                    key={i + 1}
                    className={`page-item ${currentPage === i + 1 ? "active" : ""
                      }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(i + 1)}
                    >
                      {i + 1}
                    </button>
                  </li>
                ))}

                <li
                  className={`page-item ${currentPage === totalPages ? "disabled" : ""
                    }`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageChange(currentPage + 1)}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          )}
        </div>
      </div>
    </>
  );
};

export default ViewLeaveCreditLogs;
